module.exports = __webpack_public_path__ + "static/media/pocket_square_green.7b733e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pocket_square_green.png
// module id = 128
// module chunks = 0